import { createSlice } from "@reduxjs/toolkit";
import { createNewCommunity } from "../CommunityAPI/communityApi";

const createNewCommunitySlice = createSlice({
  name: "createNewCommunity",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(createNewCommunity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNewCommunity.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createNewCommunity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default createNewCommunitySlice.reducer;
